import "./SelectedChild.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";

const SelectedChild = ({children, onClick}) => {
    return <div className={"multiselected-child"}>
        {children}
        <FontAwesomeIcon icon={faTrash} onClick={onClick}/>
    </div>
}

export default SelectedChild;